import LoadingBox from 'components/Common/Loading/LoadingBox'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { rem } from 'polished'
import React from 'react'

function ExperiencesPageBlogPostLoadingSkeleton() {
  return (<VerticalSpacer gap={12}>
    <LoadingBox style={{ height: rem(180), borderRadius: 4 }} />
    <VerticalSpacer gap={4}>
      <TextLoadingBox typography="heading6" width="100%" />
      <TextLoadingBox typography="body-small" width="100%" />
    </VerticalSpacer>
    <TextLoadingBox typography="body-medium" width={70} />
  </VerticalSpacer>)
}

export default ExperiencesPageBlogPostLoadingSkeleton
